function validate(matchString, value) {
    if (!matchString || !value) {
        return true;
    } else {
        var r = new RegExp(matchString, 'ig');
        return r.test(value);
    };
};

var RegexpValidatorLink = function ($scope, $element, $attrs, $ngModelCtrl) {
    var matchString = $attrs['regexp'];
    $ngModelCtrl.$parsers.unshift(function (viewValue) {
        $ngModelCtrl.$setValidity('regexp', validate(matchString, viewValue));
        return viewValue;
    });
    $ngModelCtrl.$formatters.unshift(function (modelValue) {
        $ngModelCtrl.$setValidity('regexp', validate(matchString, modelValue));
        return modelValue;
    });
};

RegexpValidatorLink.$inject = ['$scope', '$element', '$attrs', '$ngModelCtrl'];

var RegexpValidator = function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: RegexpValidatorLink
    };
};

module.exports = RegexpValidator;